import {
  supplierIdFormat,
  supplierProductIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

const SupplierProductInput_ = z.object({
  id: supplierProductIdFormat.schema.optional(),
  supplierId: supplierIdFormat.schema,
  productTitle: z.string().nullable(),
  supplierSku: z.string().nullable(),
  unitCost: z.number().nullable(),
  currency: z.string().nullable(),
});

export const SupplierProductInput: z.ZodType<SupplierProductInput> =
  SupplierProductInput_;
export interface SupplierProductInput
  extends z.infer<typeof SupplierProductInput_> {}

const SupplierProduct_ = z.object({
  id: supplierProductIdFormat.schema,
  supplierId: supplierIdFormat.schema,
  supplierName: z.string(),
  supplierCurrency: z.string().nullable(),
  productTitle: z.string().nullable(),
  supplierSku: z.string().nullable(),
  unitCost: z.number().nullable(),
  currency: z.string().nullable(),
  avgUnitCost: z.number().nullable(),
  mostRecentPoCost: z.number().nullable(),
});

export const SupplierProduct: z.ZodType<SupplierProduct> = SupplierProduct_;
export interface SupplierProduct extends z.infer<typeof SupplierProduct_> {}
